import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import Dropdown from '/src/components/UI/DropDown/DropDown';
import Button from "/src/components/UI/Button/Button";

import { setUpVoices } from "/src/utils/setUpVoices";
import botService from '/src/features/bot/services/botService'
import phoneService from "/src/features/administration/phone/services/phoneService"
import channelService from "../../../services/channelService"
import "./ChannelTelephony.css"
import PhoneBlock from "../../PhoneBlock/PhoneBlock"
import TextInput from "/src/components/UI/TextField/TextInput"
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { useModal } from "@ebay/nice-modal-react"

const ChannelTelephony = (({ data }) => {

    
    const modal = useModal();

    const { onClose } = useModalHelper(modal);

    const { getVoices } = botService;
    const { getChannelPhonesAvailable, updateChannel } = channelService;
    const [voices, setVoices] = useState("")
    const [phones, setPhones] = useState("")
    const [phonesChecked, setPhonesChecked] = useState("")
    const { register, control, handleSubmit, watch, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValue: {
            voices: " ",
            name : data.name
        }
    });
    const getAllVoicesById = async () => {
        let [response, error] = await getVoices(parseInt(data.bot_id))
        if (error !== null) {
            console.log(error);
            return;
        }
        setVoices(setUpVoices(response));

        return response;
    }

    const getAllPhones = async () => {

        let [response, error] = await getChannelPhonesAvailable(data.id)
        if (error !== null) {
            console.log(error);
            return;
        }
        if (response.phones_availables != null) {
            setPhones([...response.phones_availables, ...response.phones])
        }
        setPhonesChecked(response.phones)

        return response;
    }

    const checkPhone = (_phone) => {
        let result = phonesChecked;
        if (phonesChecked.filter((phone) => { return phone.id == _phone.id; }).length == 0) { // if dataset is not checked
            result.push(_phone);
            setPhonesChecked(result);
            if (result.length > 0) {
                //putValidForm(true)
            }
            document.getElementById(_phone.id + "button").style.color = "var(--green)"
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-check-circle"
        }
        else { // if dataset is already checked
            let _index = phonesChecked.findIndex(phone => { return phone.id === _phone.id });
            result.splice(_index, 1)
            setPhonesChecked(result);

            if (result.length == 0) {
                //putValidForm(false)
            }
            document.getElementById(_phone.id + "button").style.color = "var(--main)"
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-plus-circle"
        }
    }
    useEffect(() => {
        getAllVoicesById();
    }, [])

    useEffect(() => {
        getAllPhones();
    }, [])


    const onSubmit = async () => {

        let numbers = phonesChecked.map(phone => phone.id);

        let config = JSON.stringify({
            voices: getValues("voices") || "",
            language: data.data.config.language
        })

        let formData = new FormData();

        formData.append("name",getValues("name"))
        formData.append("numbers", JSON.stringify(numbers));
        formData.append("config", config);

        let [response, error] = await updateChannel(data.id, formData)
        if (error !== null) {
            console.log(error);
            return;
        }

        modal.resolve(response); // marche sans ... a voir pourquoi
        onClose();
        return;
    };
    /*
    const putValidForm = (bool) => {
        console.log(document.getElementById("form_tel"))
        document.getElementById("form_tel").disabled = !bool;
    }
    */
    return (
        <>
            <Form className="form-container_sideModal" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title className="title_channelTel"> Channel Telephony for bot {data.name}</Form.Title>
                <Form.Body className="form-body_container_sideModal channel_form-body">
                    <br></br>
                    <div>
                        <Field label={<span> Name <span className="obligatory_field">*</span> </span>} listLabelClassName="title-weigth label_color">
                            <TextInput {...register('name', { required: true, minLength: 3 })} style={{ borderColor: errors.name ? "red" : "" }} defaultValue={data.name} />
                            <span className='error' style={{ marginTop: "-15px", marginBottom: "10px", fontSize: "14px" }}>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
                        </Field>
                    </div>
                    <div className="modal-bar">
                        {
                            /**
                                                     <div style={{ display: 'flex' }}>

                            <Field label="Select your Voice" listLabelClassName="title_form title_dropdown" />
                            {
                                Array.isArray(voices) ?

                                    <Dropdown placeholder=" " {...register('voice')} setValue={setValue} choices={voices} defaultChoice="web" width="200px" className="space_dropdown"></Dropdown>
                                    :
                                    null
                            }
                        </div>
                            */
                        }
                    </div>
                    <div>
                        <Field label="Select your phone number" listLabelClassName="title_form title_dropdown" />
                        {
                            Array.isArray(phones) ?
                                phones.map((phone, i) => {
                                    return (
                                        <PhoneBlock key={phone.id} data={phone} onClick={checkPhone} index={i} />
                                    )
                                })
                                :
                                null
                        }
                    </div>
                </Form.Body>
                <Form.Buttons>
                    <Button id="form_tel" type="submit" label="Update" className="validate" disabled={!formState.isValid}/>
                </Form.Buttons>
            </Form>
        </>
    )
});

export default ChannelTelephony;